exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-14083aa8]{font-size:16px}h2[data-v-14083aa8],ul[data-v-14083aa8]{margin:0;color:#006400}ul[data-v-14083aa8]{padding:0 0 0 1.5em}li[data-v-14083aa8]{margin:1.5em 0;padding:0}b[data-v-14083aa8],li[data-v-14083aa8]{color:#006400}b[data-v-14083aa8]{margin-right:3px}.demo-app[data-v-14083aa8]{min-height:100%;font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:14px}.demo-app-main[data-v-14083aa8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:3em}", ""]);

// exports
